export default "__VITE_ASSET__da7c963d__"